<div #modalContainer_ id="modal-container" [ngClass]="{'open': showModal, 'out': hiddenModal}"
    [appScrollBlocker]="showModal">
    <div class="modal-background" (click)="(preventCloseModal) ? null : cancelModal()">
        <div class="modal fit-height" (mouseenter)="preventCloseModal=true" (mouseleave)="preventCloseModal=false"
            [ngClass]="{'overflow-visible' : config == configGeneral.CREATE_CAMPAIGN}">
            <ng-container *ngIf=" config == configGeneral.UPGRADE_BUSINESS">
                <div class="head">
                    <div class="head__tittle">
                        <h3>{{ 'GENERAL_MODAL.ACCREDIT' | translate }}</h3>
                    </div>
                </div>
                <form class="boddy">
                    <span class="text">{{ 'GENERAL_MODAL.UPGRADE_BUSINESS_DESC' | translate }}</span>
                </form>
                <div class="footer">
                    <div class="divider"></div>
                    <div class="footer__buttons">
                        <button class="btn btn__white small" (click)="cancelModalEmit()">{{ 'GENERAL_MODAL.CONTINUE' | translate }}</button>
                        <button class="btn btn__green small" (click)="contactSales()">
                            {{ 'GENERAL_MODAL.CONTACT' | translate }}
                        </button>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf=" config == configGeneral.DELETE_LIST">
                <div class="head delete">
                    <div class="head__tittle">
                        <h3>{{ 'GENERAL_MODAL.DELETE_LIST_TITLE' | translate }}</h3>
                    </div>
                </div>
                <form class="boddy">
                    <span class="text">{{ 'GENERAL_MODAL.DELETE_LIST_DESC' | translate }}</span>
                </form>
                <div class="footer">
                    <div class="divider"></div>
                    <div class="footer__buttons">
                        <button class="btn btn__white small" (click)="cancelModal()">{{ 'GENERAL_MODAL.CANCEL' | translate }}</button>
                        <button class="btn btn__blue small" (click)="deleteList(data)">
                            <span *ngIf="!loading">{{ 'GENERAL_MODAL.DELETE' | translate }}</span>
                            <div class="loader" *ngIf="loading"></div>
                        </button>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf=" config == configGeneral.DELETE_CAMPAIGN">
                <div class="head delete">
                    <div class="head__tittle">
                        <h3>{{ 'GENERAL_MODAL.DELETE_CAMPAIGN_TITLE' | translate }}</h3>
                    </div>
                </div>
                <form class="boddy">
                    <span class="text">"{{data?.name}}" {{ 'GENERAL_MODAL.PERMANENTLY_DELETED' | translate }}</span>
                </form>
                <div class="footer">
                    <!-- <div class="divider"></div> -->
                    <div class="footer__buttons">
                        <button class="btn btn__white" (click)="cancelModal()">{{ 'GENERAL_MODAL.CANCEL' | translate }}</button>
                        <button class="btn btn__blue" (click)="acceptModalEmit(data);cancelModal()">
                            <span *ngIf="!loading">{{ 'GENERAL_MODAL.DELETE' | translate }}</span>
                            <div class="loader" *ngIf="loading"></div>
                        </button>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf=" config == configGeneral.DELETE_CAMPAIGNS">
                <div class="head delete">
                    <div class="head__tittle">
                        <h3>{{ 'GENERAL_MODAL.DELETE_CAMPAIGNS_TITLE' | translate }}</h3>
                    </div>
                </div>
                <form class="boddy">
                    <span class="text">{{ 'GENERAL_MODAL.DELETE_CAMPAIGNS_DESC' | translate }}</span>
                </form>
                <div class="footer">
                    <div class="divider"></div>
                    <div class="footer__buttons">
                        <button class="btn btn__white" (click)="cancelModal()">{{ 'GENERAL_MODAL.CANCEL' | translate }}</button>
                        <button class="btn btn__blue" (click)="acceptModalEmit(data);cancelModal()">
                            <span *ngIf="!loading">{{ 'GENERAL_MODAL.DELETE' | translate }}</span>
                            <div class="loader" *ngIf="loading"></div>
                        </button>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf=" config == configGeneral.CREATE_LIST">
                <div class="head delete">
                    <div class="head__tittle">
                        <h3>{{ 'GENERAL_MODAL.CREATE_LIST_TITLE' | translate }}</h3>
                    </div>
                </div>
                <form class="boddy">
                    <span class="text">{{ 'GENERAL_MODAL.CREATE_LIST_DESC' | translate }}</span>
                </form>
                <div class="footer">
                    <div class="divider"></div>
                    <div class="footer__buttons">
                        <button class="btn btn__white" (click)="cancelModal()">{{ 'GENERAL_MODAL.CANCEL' | translate }}</button>
                        <button class="btn btn__blue" (click)="acceptModalEmit(data);cancelModal()">
                            <span *ngIf="!loading">{{ 'GENERAL_MODAL.CREATE' | translate }}</span>
                            <div class="loader" *ngIf="loading"></div>
                        </button>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf=" config == configGeneral.CREATE_CAMPAIGN">
                <div class="head delete">
                    <div class="head__tittle">
                        <h3>{{ 'GENERAL_MODAL.CREATE_CAMPAIGN_TITLE' | translate }}</h3>
                    </div>
                </div>
                <form class="boddy">
                    <span class="text">{{ 'GENERAL_MODAL.CREATE_CAMPAIGN_DESC' | translate }}</span>
                </form>
                <div class="footer">
                    <div class="divider"></div>
                    <div class="footer__buttons">
                        <!-- <combobox [items]="offers" [block]="loadingOffers" [startItem]="selectedOffer"
                            [displayProperty]="'discount'">
                        </combobox> -->
                        <button class="btn btn__white" (click)="cancelModal()">{{ 'GENERAL_MODAL.CANCEL' | translate }}</button>
                        <button class="btn btn__blue" (click)="acceptModalEmit(data);cancelModal()">
                            <span *ngIf="!loading">{{ 'GENERAL_MODAL.CREATE' | translate }}</span>
                            <div class="loader" *ngIf="loading"></div>
                        </button>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf=" config == configGeneral.DELETE_COMMISIONS">
                <div class="head delete">
                    <div class="head__tittle">
                        <h3>{{ 'GENERAL_MODAL.DELETE_COMMISSION_TITLE' | translate }}</h3>
                    </div>
                </div>
                <form class="boddy">
                    <span class="text">{{ 'GENERAL_MODAL.DELETE_COMMISSION_DESC' | translate }}</span>
                </form>
                <div class="footer">
                    <div class="divider"></div>
                    <div class="footer__buttons">
                        <button class="btn btn__white" (click)="cancelModal()">{{ 'GENERAL_MODAL.CANCEL' | translate }}</button>
                        <button class="btn btn__blue" (click)="acceptModalEmit(data);cancelModal()">
                            <span *ngIf="!loading">{{ 'GENERAL_MODAL.ACCEPT' | translate }}</span>
                            <div class="loader" *ngIf="loading"></div>
                        </button>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf=" config == configGeneral.DISABLED_CAMPAIGN">
                <div class="head delete">
                    <div class="head__tittle">
                        <h3>{{ (data.state == 1 ? 'GENERAL_MODAL.DISABLE_CAMPAIGN_TITLE' : 'GENERAL_MODAL.ENABLE_CAMPAIGN_TITLE') | translate }}</h3>
                    </div>
                </div>
                <form class="boddy">
                    @if (data.state == 1) {
                    <span class="text">{{ 'GENERAL_MODAL.DISABLE_CAMPAIGN_DESC' | translate }}</span>
                    }@else {
                    <span class="text">{{ 'GENERAL_MODAL.ENABLE_CAMPAIGN_DESC' | translate }}</span>
                    }
                </form>
                <div class="footer">
                    <div class="divider"></div>
                    <div class="footer__buttons">
                        <button class="btn btn__white" (click)="cancelModal()">{{ 'GENERAL_MODAL.CANCEL' | translate }}</button>
                        <button class="btn btn__blue" (click)="acceptModalEmit(data);cancelModal()">
                            <span *ngIf="!loading">{{ 'GENERAL_MODAL.ACCEPT' | translate }}</span>
                            <div class="loader" *ngIf="loading"></div>
                        </button>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="config == configGeneral.CREATE_VERSION">
                <div class="head">
                    <div class="head__tittle">
                        <h3>{{ 'GENERAL_MODAL.PUBLISH_VERSION' | translate }} {{data?.current != data?.latest ? (`v` + data?.current) :
                            ('GENERAL_MODAL.LATEST' | translate)}}</h3>
                    </div>
                </div>
                <form class="boddy">
                    <input class="input-slim" type="text" [(ngModel)]="versionName" name="versionName"
                        [placeholder]="'GENERAL_MODAL.VERSION_NAME_PLACEHOLDER' | translate">
                </form>
                <div class="footer">
                    <div class="divider"></div>
                    <div class="footer__buttons">
                        <button class="btn btn__white small" style="border: none"
                            (click)="cancelModalEmit()">{{ 'GENERAL_MODAL.CANCEL' | translate }}</button>
                        <button class="btn btn__blue small" (click)="createVersion()">
                            {{ 'GENERAL_MODAL.CREATE' | translate }}
                        </button>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="config == configGeneral.DISABLED_RESOURCES">
                <div class="head delete">
                    <div class="head__tittle">
                        <h3>{{ 'GENERAL_MODAL.PUBLISH_RESOURCE_TITLE' | translate }}</h3>
                    </div>
                </div>
                <form class="boddy">
                    <span class="text">{{ 'GENERAL_MODAL.PUBLISH_RESOURCE_DESC' | translate }}</span>

                </form>
                <div class="footer">
                    <div class="divider"></div>
                    <div class="footer__buttons">
                        <button class="btn btn__white small" style="border: none"
                            (click)="cancelModalEmit()">{{ 'GENERAL_MODAL.CANCEL' | translate }}</button>
                        <button class="btn btn__blue small" (click)="acceptModalEmit()">
                            {{ 'GENERAL_MODAL.PUBLISH' | translate }}
                        </button>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="config == configGeneral.DELETE_RESOURCES">
                <div class="head delete">
                    <div class="head__tittle">
                        <h3>{{ 'GENERAL_MODAL.DELETE_RESOURCE_TITLE' | translate }}</h3>
                    </div>
                </div>
                <form class="boddy">
                    <span class="text">{{ 'GENERAL_MODAL.DELETE_RESOURCE_DESC' | translate }}</span>
                </form>
                <div class="footer">
                    <div class="divider"></div>
                    <div class="footer__buttons">
                        <button class="btn btn__white small" style="border: none"
                            (click)="cancelModalEmit()">{{ 'GENERAL_MODAL.CANCEL' | translate }}</button>
                        <button class="btn btn__blue small" (click)="acceptModalEmit()">
                            @if (data?.loading) {
                            <span class="loader white"></span>
                            }@else{
                            {{ 'GENERAL_MODAL.DELETE' | translate }}
                            }
                        </button>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>